import React, { useEffect, useRef, useState } from "react";
import { AiOutlineClockCircle } from "react-icons/ai";
import { BsStopwatch, BsGear } from "react-icons/bs";
import { BiUnlink, BiPowerOff } from "react-icons/bi";
import { TbRestore } from "react-icons/tb";
import { MdSystemUpdateAlt, MdCheck } from "react-icons/md";
import ActionMenu from "../../components/ActionMenu";

const DeviceCardMenu = ({
    anchorRect,
    bulkCount = 1,
    isUnderMaintenance = false,
    onAddMaintenance,
    onUnderMaintenance,
    onConfigure,
    onUnbind,
    onReboot,
    onUpdateFirmware,
    onFactoryReset,
    onClose,
}) => {
    const ref = useRef(null);
    const [style, setStyle] = useState(null);

    useEffect(() => {
        const onDocClick = (e) => {
            if (ref.current && !ref.current.contains(e.target)) onClose?.();
        };
        document.addEventListener("click", onDocClick);
        return () => document.removeEventListener("click", onDocClick);
    }, [onClose]);

    useEffect(() => {
        if (!anchorRect) return;
        const menuWidth = 320; // tw-w-80 = 20rem ≈ 320px

        let left = Math.min(
            anchorRect.right - menuWidth,
            window.innerWidth - menuWidth - 8,
        );
        left = Math.max(8, left);
        let top = anchorRect.bottom + 8;

        setStyle({
            position: "fixed",
            left,
            top,
            zIndex: 9999,
            width: menuWidth,
        });

        const id = requestAnimationFrame(() => {
            if (!ref.current) return;
            const h = ref.current.offsetHeight;
            const belowSpace = window.innerHeight - anchorRect.bottom - 8;
            const aboveSpace = anchorRect.top - 8;
            if (belowSpace < h && aboveSpace > h) {
                setStyle({
                    position: "fixed",
                    left,
                    top: anchorRect.top - h - 8,
                    zIndex: 9999,
                    width: menuWidth,
                });
            }
        });
        return () => cancelAnimationFrame(id);
    }, [anchorRect]);

    const containerProps = style
        ? { style }
        : {
              className: "tw-absolute tw-right-0 tw-top-9 tw-z-[9999]",
          };

    return (
        <ActionMenu ref={ref} {...containerProps}>
            <ActionMenu.Item
                icon={<AiOutlineClockCircle size={18} />}
                label="Add Scheduled Maintenance"
                onClick={onAddMaintenance}
                withDivider
            />
            <ActionMenu.Item
                icon={<BsStopwatch size={18} />}
                label={
                    isUnderMaintenance
                        ? "Clear Maintenance"
                        : "Under Maintenance"
                }
                activeRed={isUnderMaintenance}
                onClick={onUnderMaintenance}
                withDivider
            />
            <ActionMenu.Item
                icon={<BsGear size={18} />}
                label="Configure"
                onClick={onConfigure}
                withDivider
            />
            <ActionMenu.Item
                icon={<BiUnlink size={18} />}
                label="Unbind Device"
                onClick={onUnbind}
                withDivider
            />
            <ActionMenu.Item
                icon={<MdSystemUpdateAlt size={18} />}
                label="Update firmware"
                onClick={onUpdateFirmware}
                withDivider
                disabled={bulkCount > 1}
                title={
                    bulkCount > 1
                        ? "Select exactly 1 device to update firmware"
                        : undefined
                }
            />
            <ActionMenu.Item
                icon={<TbRestore size={18} />}
                label="Factory reset"
                onClick={onFactoryReset}
                withDivider
            />
            <ActionMenu.Item
                icon={<BiPowerOff size={18} />}
                label="Reboot device"
                danger
                onClick={onReboot}
            />
        </ActionMenu>
    );
};

export default DeviceCardMenu;
